import { toast } from 'react-toastify';
import AsnAPI from '../../../Api/asn';

const generatePoLineUnitLabelZPL = async (
  userId: string,
  lineId: string,
  numLabels: number,
) => {
  try {
    const response = await AsnAPI.getPoLineUnitLabelData(
      userId,
      lineId,
      numLabels > 0 ? numLabels : undefined,
    );
    if (!response) {
      toast('Failed to get the purchase order line data', {
        type: 'error',
      });
      return null;
    }
    return {
      zpl: response.zpl,
      request_id: response.request_id,
    };
  } catch (error: unknown) {
    console.error('Failed to get the purchase order line data', error);
    toast('Failed to get the purchase order line data', {
      type: 'error',
    });
    return null;
  }
};

const generatePoUnitLabelZPL = async (
  userId: string,
  internalId: string,
  numLabels: number,
) => {
  try {
    const response = await AsnAPI.getPoUnitLabelData(
      userId,
      internalId,
      numLabels,
    );
    if (!response) {
      toast('failed to get the po label data', {
        type: 'error',
      });
      return null;
    }

    return response;
  } catch (error: unknown) {
    console.error('Failed to get the purchase order line data', error);
    toast('Failed to get the purchase order line data', {
      type: 'error',
    });
    return null;
  }
};

export { generatePoLineUnitLabelZPL, generatePoUnitLabelZPL };
